import React from 'react'

export const HiddenSelect = React.forwardRef<
  HTMLSelectElement,
  {
    value: string | number | readonly string[] | undefined
    name: string | undefined
    form: string | undefined
    isRequired?: boolean
    children?: React.ReactNode
    autoComplete?: string
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => unknown
  }
>(({ value, name, form, isRequired, children, autoComplete, onChange }, ref) => {
  return (
    <div
      style={{
        border: 0,
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px',
        whiteSpace: 'nowrap'
      }}
    >
      {/* Deliberately unlabelled. This <select> exists only to carry the field's value into the
          submitted FormData; it is aria-hidden and untabbable, so it must expose no accessible name.
          Wrapping it in a <label> holding the visible label text gave every migrated Select two
          elements answering to the same name — the leaked text also reached the a11y tree, which
          announced the label twice ("Category Category"). The visible label belongs to the RAC
          trigger alone. */}
      <select
        aria-required={isRequired}
        required={isRequired}
        tabIndex={-1}
        aria-hidden="true"
        value={value}
        ref={ref}
        name={name}
        form={form}
        autoComplete={autoComplete}
        onChange={onChange}
      >
        <option value="" />
        {children}
      </select>
    </div>
  )
})
HiddenSelect.displayName = 'HiddenSelect'
